import TaskTimer from './timer';

interface IMessage {
  msgId: string;
  report: string;
  data: any;
}

type MessageHandler = (msg: any) => void;

export default class RIWebSocket {
  wsHeartbeat: TaskTimer;
  wsTimeOffsetTask: TaskTimer;
  webSocket?: WebSocket;
  userCloseWS = false;
  lockReconnect = false;
  url = '';
  messageHandler?: MessageHandler;

  constructor(url: string, messageHandler?: MessageHandler) {
    this.url = url;
    this.wsHeartbeat = new TaskTimer(15000, () => {
      this.sendMessage({ method: 'HB' });
    });
    this.wsTimeOffsetTask = new TaskTimer(30000, () => {
      this.sendMessage({ method: 'business.ping' });
    });
    this.messageHandler = messageHandler;
  }

  connectWebSocket() {
    this.wsHeartbeat.reset();
    this.wsTimeOffsetTask.reset();

    try {
      if ('WebSocket' in window) {
        this.closeWebSocket();
        this.webSocket = this.createWebSocket();
      } else {
        console.log('Your browser do not support webSocket!');
      }
    } catch (e) {
      console.error(e);
      this.reconnect();
    }
  }
  reconnect() {
    if (this.lockReconnect) {
      return;
    }
    this.lockReconnect = true;
    setTimeout(() => {
      this.lockReconnect = false;
      if (this.webSocket?.readyState !== WebSocket.OPEN) {
        this.connectWebSocket();
      }
    }, 5000);
  }

  createWebSocket(): WebSocket {
    this.userCloseWS = false;
    const webScoket = new WebSocket(this.url);

    webScoket.onclose = (event) => {
      console.log('webSocket服务关闭了:', event);
      if (this.userCloseWS) return;
      this.reconnect();
    };
    webScoket.onerror = (err) => {
      console.error('webSocket服务出错了', err);
      this.reconnect();
    };
    webScoket.onopen = () => {
      console.log('webSocket服务连上了');
      this.wsHeartbeat.start();
      this.wsTimeOffsetTask.runTask();
    };
    webScoket.onmessage = (event) => {
      const msg = event.data;
      if (msg === 'OK') {
        this.wsHeartbeat.start();
      } else {
        this.handleMessage(msg);
      }
    };

    return webScoket;
  }

  handleMessage(message: string) {
    if (this.webSocket) {
      const { msgId = '', report = '', data } = JSON.parse(message) as IMessage;
      this.sendMessage({ ack: msgId });
      if (report === 'business.pong') {
        this.wsTimeOffsetTask.start();
      }
      this.messageHandler?.({ report, data });
    }
  }

  sendMessage(data: { [k: string]: any } = {}) {
    this.webSocket?.send(JSON.stringify(data));
  }

  getListCameraStatus(deviceIds: (string | number)[] = []) {
    if (deviceIds.length > 0) {
      this.sendMessage({
        method: 'business.service.cam.list.status',
        msgId: new Date().valueOf(),
        params: { deviceIds },
      });
    }
  }

  sendStreamFlvPing(flvUrl: string) {
    if (!flvUrl || this.webSocket?.readyState !== WebSocket.OPEN) return;
    const timestamp = new Date().valueOf();
    this.sendMessage({
      method: 'business.stream.flv.ping',
      data: flvUrl,
      msgId: timestamp,
      timestamp,
    });
  }

  closeWebSocket() {
    try {
      this.userCloseWS = true;
      this.wsHeartbeat?.reset();
      this.webSocket?.close();
    } catch (error) {
      console.error('closeWebSocket error', error);
    }
    this.webSocket = undefined;
  }
}
